
import { useSession as useBaseSession } from '@/core/auth/useSession';

/**
 * Application-specific session hook that extends the generic implementation
 * with any additional application-specific functionality
 */
export const useSession = () => {
  const baseSession = useBaseSession();
  
  // Add any application-specific session logic here
  
  return baseSession;
};
